import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  backgroundColor: '#161616',
  color: '#ffffff',
  border: 'none',
  fontFamily: '"Poppins", sans-serif',
  fontSize: '0.8125rem',
  
  // Global scrollbar styles for the entire component
  '& *::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '& *::-webkit-scrollbar-track': {
    background: '#121212',
  },
  '& *::-webkit-scrollbar-thumb': {
    background: '#333',
    borderRadius: '3px',
  },
  '& *::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
  '.MuiDataGrid-columnHeaders': {
    backgroundColor: '#222',
    color: '#ffffff',
    fontWeight: 600,
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    minHeight: '36px !important',
    maxHeight: '36px !important',
    lineHeight: '36px',
    fontSize: '0.75rem',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 600,
  },
  '.MuiDataGrid-cell': {
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    padding: '2px 8px',
    minHeight: '45px !important', // Increased height
    maxHeight: '45px !important',
  },
  '.MuiDataGrid-row': {
    minHeight: '45px !important', // Increased height
    maxHeight: '45px !important',
  },
  '.MuiDataGrid-row:nth-of-type(odd)': {
    backgroundColor: '#181818',
  },
  '.MuiDataGrid-row:nth-of-type(even)': {
    backgroundColor: '#1d1d1d',
  },
  '.MuiDataGrid-row:hover': {
    backgroundColor: '#2a2a2a',
    cursor: 'pointer',
  },
  '.MuiDataGrid-virtualScroller': {
    overflow: 'auto !important', // Force scrolling
  },
  
  // Direct styling for the scrollable containers
  '.MuiDataGrid-virtualScrollerRenderZone': {
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#121212',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#333',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
  
  // Horizontal scrollbar
  '.MuiDataGrid-horizontalScrollbar': {
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#121212',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#333',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  },
  '.MuiDataGrid-footerContainer': {
    display: 'none',
  },
  // No cell outline on focus
  '.MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  // Compact row spacing
  '.MuiDataGrid-viewport': {
    lineHeight: 1.2,
  },
  // Ensure proper scrolling
  '&.MuiDataGrid-autoHeight': {
    '& .MuiDataGrid-virtualScroller': {
      overflow: 'visible !important',
    },
  },
}));
